import React, { useEffect, useState } from "react";
import { Card, Table, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { formatDate } from "../../helpers/date";
import useAxiosPost from "../../hooks/useAxiosPost";
import { notifyError } from "../toast/Error";
import { notifySuccess } from "../toast/Success";
import AssignVlanToDealerModal from "../Model/AssignVlanToDealerModal";
import "./../../assets/styles/olt.css";
import "./../../assets/styles/ont-list.css";
type Props = {
  isLoggedIn?: boolean;
};

const ViewDealerVlansComponent: React.FC<Props> = ({}) => {
  const [
    getSuperCOOData,
    getSuperCOOResponse,
    COOError,
    COOLoading,
    COOMessage,
    COOErrorCount,
  ] = useAxiosPost<DealerVlansProp>("vlans/getAllVlansRelatedToDealer");

  const [dealerVlans, setDealerVlans] = useState<any>([]);
  const [filteredVlans, setFilteredVlans] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const { intPkUserID } = useParams();

  // API call to delete VLAN from dealer
  const [
    deleteVlanData,
    deleteVlanResponse,
    deleteVlanError,
    deleteVlanLoading,
    deleteVlanMessage,
    deleteVlanErrorCount,
  ] = useAxiosPost<any>("vlans/deleteVlanM2MDealer");

  useEffect(() => {
    getSuperCOOData({ intPkUserID: Number(intPkUserID) });
  }, []);

  const [showAssignModal, setShowAssignModal] = useState<boolean>(false);

  const handleCloseAssignModal = (isCall: boolean) => {
    setShowAssignModal(false);
    if (isCall === true) {
      getSuperCOOData({ intPkUserID: Number(intPkUserID) });
    }
  };

  const handleDeleteVlan = (intPkVlanM2MDealerID: number, vlanName: string) => {
    confirmAlert({
      title: "Delete VLAN Assignment",
      message: `Are you sure you want to delete the VLAN assignment for "${vlanName}"?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            console.log("User confirmed deletion");
            deleteVlanData({ intPkVlanM2MDealerID });
          },
        },
        {
          label: "No",
          onClick: () => {
            console.log("User cancelled deletion");
          },
        },
      ],
      overlayClassName: "overlay-custom-class-name-for-alert",
    });
  };

  const handleSearch = (searchValue: string) => {
    setSearchTerm(searchValue);

    if (!searchValue.trim()) {
      setFilteredVlans(dealerVlans);
      return;
    }

    const filtered = dealerVlans.filter((vlan: any) => {
      const vlanName = (vlan.vlanName || "").toLowerCase();
      const ispName = (vlan.ispName || "").toLowerCase();
      const searchLower = searchValue.toLowerCase();

      return vlanName.includes(searchLower) || ispName.includes(searchLower);
    });

    setFilteredVlans(filtered);
  };

  useEffect(() => {
    if (COOError !== null && COOErrorCount !== 0) {
      notifyError(COOError);
    }
  }, [COOError, COOErrorCount]);

  useEffect(() => {
    if (deleteVlanError !== null && deleteVlanErrorCount !== 0) {
      notifyError(deleteVlanError);
    }
  }, [deleteVlanError, deleteVlanErrorCount]);

  useEffect(() => {
    if (deleteVlanResponse !== null) {
      notifySuccess("VLAN deleted successfully");
      getSuperCOOData({ intPkUserID: Number(intPkUserID) });
    }
  }, [deleteVlanResponse]);

  useEffect(() => {
    if (getSuperCOOResponse !== null) {
      console.log({ getSuperCOOResponse });
      const vlans = Array.isArray(getSuperCOOResponse.responseData)
        ? getSuperCOOResponse.responseData
        : [];

      // Sort first by ispName (ascending), then by vlan (ascending)
      const sortedVlans = [...vlans].sort((a: any, b: any) => {
        // First sort by ispName (ascending)
        const ispNameA = String(a.ispName || "")
          .toLowerCase()
          .trim();
        const ispNameB = String(b.ispName || "")
          .toLowerCase()
          .trim();

        console.log(
          `Comparing ISP: "${a.ispName}" -> "${ispNameA}" vs "${b.ispName}" -> "${ispNameB}"`
        );

        const ispResult = ispNameA.localeCompare(ispNameB, "en", {
          numeric: true,
        });
        console.log(`ISP comparison result: ${ispResult}`);

        if (ispResult !== 0) {
          return ispResult;
        }

        // If ISP names are the same, sort by vlan (ascending)
        const vlanA = Number(a.vlan) || 0;
        const vlanB = Number(b.vlan) || 0;

        console.log(
          `ISP same (${ispNameA}), comparing VLAN: ${vlanA} vs ${vlanB}`
        );

        const vlanResult = vlanA - vlanB;
        console.log(`VLAN comparison result: ${vlanResult}`);
        return vlanResult;
      });

      console.log(
        "Sorted VLANs:",
        sortedVlans.map((v) => ({ vlan: v.vlan, ispName: v.ispName }))
      );

      setDealerVlans(sortedVlans);
      setFilteredVlans(sortedVlans);
    }
  }, [getSuperCOOResponse]);

  return (
    <>
      <ToastContainer />

      <Row className="justify-content-center">
        <Col xs lg="12" md="12" xl="12" className="p-5">
          <Card className="p-5">
            <Card.Title className="text-center olt-heading fw-700 pt-3 ">
              {" "}
              Dealer Vlans
              <span style={{ float: "right" }}>
                <Button
                  variant="success"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowAssignModal(true);
                  }}
                >
                  Assign VLAN
                </Button>
              </span>
            </Card.Title>

            {/* Search Bar */}
            <Row className="mt-3 mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Search VLANs</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Search by VLAN name or ISP name..."
                    value={searchTerm}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="d-flex align-items-end">
                <div className="mb-3">
                  <small className="text-muted">
                    Showing {filteredVlans.length} of {dealerVlans.length} VLANs
                  </small>
                </div>
              </Col>
            </Row>
            <Row className="mt-5">
              <Col md={12} lg={12} xs={12} sm={12} xl={12} xxl={12}>
                <Table bordered>
                  <thead>
                    <tr>
                      <th className="table-header-standard">VLAN Name</th>
                      <th className="table-header-standard">VLAN Value</th>
                      <th className="table-header-standard">ISP Name</th>
                      <th className="table-header-standard">Status</th>
                      <th className="table-header-standard">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredVlans.length > 0 ? (
                      filteredVlans.map((vlan: any, index: number) => {
                        return (
                          <tr key={vlan.intPkVlanID || index}>
                            <td>{vlan.vlanName || "N/A"}</td>
                            <td>{vlan.vlan || "N/A"}</td>
                            <td>{vlan.ispName || "N/A"}</td>
                            <td>
                              <span
                                className={`badge ${
                                  vlan.enable === 1 ? "bg-success" : "bg-danger"
                                }`}
                              >
                                {vlan.enable === 1 ? "Enabled" : "Disabled"}
                              </span>
                            </td>
                            <td>
                              <Button
                                variant="danger"
                                size="sm"
                                onClick={() =>
                                  handleDeleteVlan(
                                    vlan.intPkVlanM2MDealerID,
                                    vlan.vlanName
                                  )
                                }
                                disabled={deleteVlanLoading}
                              >
                                {deleteVlanLoading ? "Deleting..." : "Delete"}
                              </Button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={5} className="text-center">
                          No VLANs assigned to this dealer
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      {/* Assign VLAN Modal */}
      {intPkUserID && (
        <AssignVlanToDealerModal
          show={showAssignModal}
          handleClose={handleCloseAssignModal}
          intPkUserID={Number(intPkUserID)}
          dealerName={`Dealer`}
        />
      )}
    </>
  );
};
export default ViewDealerVlansComponent;
